module.exports = __webpack_public_path__ + "historicalAllocations.337ae720af3b4b1e0b98feabbe41ad9c.png";